module.exports = __webpack_public_path__ + "static/media/postman.48a62488.png";